import { makeStyles } from '@material-ui/core/styles'

const useMenuTitleStyles = makeStyles(() => ({
    titleRoot: {
        '&:hover': {
            backgroundColor: 'transparent',
            cursor: 'default',
        }
    },
    subTitle: {
        '& span': {
            fontStyle: 'normal',
            fontWeight: '400 !important',
            fontSize: '13px !important',
            lineHeight: '18px !important',
            color: '#707070',
            marginTop: '-1rem',
            paddingBottom: '1.5rem'
        }
    },
    default: {
        '& span': {
            fontStyle: 'normal',
            fontWeight: '700 !important',
            fontSize: '13px !important',
            lineHeight: '18px !important',
            color: '#989898',
            marginTop: '-4px',
        }
    },
    title2: {
        '& span': {
            fontStyle: 'normal',
            fontWeight: '700 !important',
            fontSize: '16px !important',
            lineHeight: '22px !important',
            color: '#333333',            
            marginTop: '-4px',
            paddingBottom: '1.5rem'
        }
    },
}), { name: 'MuiMenuItem' });

export default useMenuTitleStyles